import React from 'react';
import  { useState } from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  FormLabel,
  Textarea,
} from '@chakra-ui/react';
import Select from 'react-select';
import './ContractFinance.css';
import {  Trash } from 'lucide-react';


function ContractForm(props) {

  const [formData,setFormData]=useState(
    {
      franchiseeAccount: "",
      jobType:"",
      customerName:""
      
    });
    const [franchiseeAccount, setFranchiseeAccount] = useState([])
    const [customerName, setCustomerName] = useState([])
  const { closeDrawer } = props;
  const handleOnClose = () => {
    closeDrawer();
  };
  const handleSubmit = ()=>{
    closeDrawer();
  }

  const customStyle = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      borderColor: state.isFocused ? 'silver' : 'rgb(93, 135, 255)',
      borderRadius: "20px",
      border: '0.5px solid rgb(196,196,196,0.5) !important'
    }),
  }
  
  const [rows, setRows] = useState([
    { itemDetails: '', ACCOUNT: '', ANNUALQTY : '', SERVPCLEAN: '', ANNUALCONTRACTVALUE:'', QUANTITY:'', RATE:'', TAX:'', CUSTOMERDETAILS:'', AMOUNT:'', }
  ]);

  const addRow = () => {
    setRows([...rows, { itemDetails: '', ACCOUNT: '', ANNUALQTY : '', SERVPCLEAN: '', ANNUALCONTRACTVALUE:'', QUANTITY:'', RATE:'', TAX:'', CUSTOMERDETAILS:'', AMOUNT:'',}]);
  };
  const deleteRow = (index) => {
    setRows(rows.filter((_, i) => i !== index));
  };

  return (
    <>
      <Drawer
        isOpen={props.isDrawerOpen}
        placement='right'
        size='xl'
        onClose={handleOnClose}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader> Create Estimate </DrawerHeader>
          <DrawerBody>
            <form>
            <div className='row '>
            <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <Select name='customerName' options={customerName} defaultValue={customerName.find((item)=>(item.value === formData?.customerName))}  onChange={(option) => { setFormData(prevFormData => ({...prevFormData,customerName:option.value }))}} styles={customStyle} />
                  <FormLabel className="small-label ps-3"> Customer Name</FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Estimate' name='estimate'/>
                  </div>
                  <FormLabel className="small-label ps-3">Estimate </FormLabel>
                </div>
              </div>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Reference' name='reference'/>
                  </div>
                  <FormLabel className="small-label ps-3 ps-2">Reference</FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='date' style={{ outline: "none", border: "none" }} placeholder='Estimate Date' name='estimatedate'/>
                  </div>
                  <FormLabel className="small-label ps-3">Estimate Date </FormLabel>
                </div>
              </div>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='date' style={{ outline: "none", border: "none" }} placeholder='Expiry Date' name='expirydate'/>
                  </div>
                  <FormLabel className="small-label ps-3 ps-2">Expiry Date</FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                  <select className='rounded' type='text' placeholder="Salesperson" style={{ width: '100%', backgroundColor:'white'}}   >
                      <option value={'Dan Mahida'}> Dan Mahida</option>
                      <option value={''} > </option>
                      
                    </select>
                  </div>
                  <FormLabel className="small-label ps-3">Sales Person</FormLabel>
                </div>
              </div>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                  <select className='rounded' type='text' placeholder=" " style={{ width: '100%', backgroundColor:'white',outline:'none'}}   >
                      <option value={''}> </option>
                      <option value={''} > </option>
                    </select>
                  </div>
                  <FormLabel className="small-label ps-3 ps-2">Project Name</FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                  <select className='rounded' type='text' placeholder=" " style={{ width: '100%', backgroundColor:'white',outline:"none"}}   >
                      <option value={'Monday'}>Monday </option>
                      <option value={'Tuesday'} >Tuesday </option>
                      <option value={'Wednesday'}>Wednesday </option>
                      <option value={'Thursday'} >Thursday </option>
                      <option value={'Friday'}>Friday </option>
                      <option value={'Saturday'} >Saturday </option>
                      <option value={'Sunday'} >Sunday</option>
                      
                    </select>
                  </div>
                  <FormLabel className="small-label ps-3 ps-2">Working Days</FormLabel>
                </div>
              </div>
              <div className='row '>
              <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                <div className='search-by-title'>
                <select className='rounded' type='text' placeholder=" " style={{ width: '100%', backgroundColor:'white',outline:"none"}}   >
                      <option value={'Weekly'}> Weekly</option>
                      <option value={'Monthly'} >Monthly </option>
                      <option value={'Fortnightly'}> Fortnightly</option>
                      <option value={'One-off'} >One-off </option>
                    </select>
                  </div>
                  <FormLabel className="small-label ps-3 ps-2">Frequency</FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='date' style={{ outline: "none", border: "none" }} placeholder='' name='recurringsOstartdate'/>
                  </div>
                  <FormLabel className="small-label ps-3">Recurring S/O Start Date </FormLabel>
                </div>
              </div>
              <div className='row '>
              <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <Select name='franchiseeAccount' options={franchiseeAccount} defaultValue={franchiseeAccount.find((item)=>(item.value === formData?.franchiseeAccount))}  onChange={(option) => { setFormData(prevFormData => ({...prevFormData,franchiseeAccount:option.value }))}} styles={customStyle} />
                  <FormLabel className="small-label ps-3"> Franchisee Account</FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                <div className='search-by-title'>
                <select className=' rounded' name='jobType' type='text' placeholder="Job Type" style={{ width: '100%',outline:"none" }}   >
                <option value="Regular">Regular</option>
                    <option value="One-Off Job">One-Off Job</option>
                    </select>
                </div>
                  <FormLabel className="small-label ps-3" style={{ paddingLeft: "6px" }}>Job Type</FormLabel>
                </div>
              </div>
               <div className='row '>
               <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                <div className=''>
                    <div className="row  mt-3">
                    <div className="col-5"><FormLabel className="small-label ps-3">Recurring S/O</FormLabel></div>
                      <div className="col-5">
                  <input className="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="option1" checked />
                 </div>
                  </div>
                  </div>
                </div>
              </div>
              <div className='row '>
                {/* <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Create ID' name='createid'/>
                  </div>
                  <FormLabel className="small-label ps-3 ps-2">Create ID</FormLabel>
                </div> */}
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                </div>
              </div>
              <div className='w-100 ' style={{ overflow: "hidden" }} >
              <div className='custom-scroll'>
                <table className='table-class'>
                  <thead>
                    <tr>
                      <th colSpan={9}><h5 style={{fontSize:'15px'}}>Item Table</h5></th>
                      
                    </tr>
                    <tr className='border'>
                    <th className='border'>ACTION</th>
                      <th className='border' style={{textAlign:"center"}}>SERVICES</th>
                      
                      <th className='border' style={{textAlign:"center"}}>ANNUAL QTY</th>
                      <th className='border' style={{textAlign:"center"}}>SERV P/CLEAN </th>
                      <th className='border' style={{textAlign:"center"}}>ANNUAL CONTRACT VALUE </th>
                      <th className='border' style={{textAlign:"center"}}>QUANTITY</th>
                      <th className='border' style={{textAlign:"center"}}>	RATE</th>
                      <th className='border' style={{textAlign:"center"}}>TAX</th>
                    
                      <th className='border'>AMOUNT </th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, index) => (
                      <tr key={index}>
                        <td className='border text-center table-class'>
                          <button onClick={() => deleteRow(index)} className='delete-button'>
                          <Trash size={16} color='#dd0b58' />
                          </button>
                        </td>
                        <td className='border table-class'>
                          <Select type='text' value={row.itemDetails} onChange={(e) => {
                            const newRows = [...rows]; newRows[index].itemDetails = e.target.value; setRows(newRows);
                          }} />
                        </td>
                        <td className='border table-class'>
                          <input style={{outline:"none"}} type='number' value={row.qty} onChange={(e) => { const newRows = [...rows]; newRows[index].qty = e.target.value; setRows(newRows); }} />
                        </td>
                        
                        <td className='border table-class'>
                          <input style={{outline:"none"}}  type='text' value={row.tax} onChange={(e) => { const newRows = [...rows]; newRows[index].tax = e.target.value; setRows(newRows); }} />
                        </td>
                        <td className='border table-class'>
                        <input style={{outline:"none"}}  type='text' value={row.tax} onChange={(e) => { const newRows = [...rows]; newRows[index].tax = e.target.value; setRows(newRows); }} />
                        </td>
                        <td className='border table-class'>
                          <input style={{outline:"none"}}  type='text' value={row.rate} onChange={(e) => { const newRows = [...rows]; newRows[index].rate = e.target.value; setRows(newRows); }} />
                        </td>
                        <td className='border table-class'>
                          <input style={{outline:"none"}}  type='text' value={row.tax} onChange={(e) => { const newRows = [...rows]; newRows[index].tax = e.target.value; setRows(newRows); }} />
                        </td>
                        <td className='border table-class'>
                        <input style={{outline:"none"}}  type='text' value={row.tax} onChange={(e) => { const newRows = [...rows]; newRows[index].tax = e.target.value; setRows(newRows); }} />
                        </td>
                        
                        <td className='border table-class'>
                        <input style={{outline:"none"}}  type='text' value={row.tax} onChange={(e) => { const newRows = [...rows]; newRows[index].tax = e.target.value; setRows(newRows); }} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <button style={{ color: "#dd0b58" }} onClick={addRow}><b> + Add Row</b></button>
              </div>
              <div className='row'>
                <div className='d-flex justify-content-end align-items-center w-100'>
              <div className="card mt-3" style={{ width: '50%' }}>
                <div className="card-body">
                  <div className='row'>
                    <div className='col-lg-6'>
                    <p><b>Sub Total</b></p>
                    </div>
                    <div className='col-lg-6 text-end'>
                    <p><b>0.00</b></p>
                    </div>
                  </div>
                  <div className='row' style={{borderBottom:"1px solid #e5e5e5"}}>
                    <div className='col-lg-3'>
                    <input style={{outline:'none'}} type='text' placeholder='Adjustment'/>
                    </div>
                    <div className='col-lg-3'>
                    <input style={{outline:'none'}} type='text' />
                    </div>
                    <div className='col-lg-6 text-end'>
                    <p>0.00</p>
                    </div>
                  </div>
                  <div className='row mt-2'>
                  <div className='col-lg-6'>
                  <p><b>Total</b></p>
                  </div>
                  <div className='col-lg-6 text-end'>
                  <p><b>0.00</b></p>
                  </div>
                  </div>
                </div>
              </div>
              </div>
                </div>
              </div>
              <div className='row mt-3 mb-2'>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                <Textarea type='text' style={{ border: "1px solid grey" }} placeholder='Notes on Pricing' />
                  <FormLabel className="small-label ps-3">Notes on Pricing</FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                <Textarea type='text' style={{ border: "1px solid grey" }} placeholder='Ad hoc Service CCS can provide' />
                <FormLabel className="small-label ps-3">Ad hoc Service CCS can provide</FormLabel>
                </div>
              </div>
              <div className='row justify-content-center '>
                <div className=' col-lg-12 mb-2 '>
                  <label htmlFor="imageUpload" className="image-upload" style={{ border: '2px dashed lightgrey', borderRadius: '10px', width: '100%', height: '100px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <input type="file" id="imageUpload" name="image" multiple />
                    <div className="image-upload-content" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                      <i className="fas fa-cloud-upload-alt" style={{ fontSize: '24px', marginBottom: '5px' }}></i>
                      {/* <p style={{ textAlign: 'center', margin: '0' }}>Add Attachements</p> */}
                    </div>
                  </label>
                  <FormLabel className="small-label ps-3">Add Attachements</FormLabel>
                </div>
              </div>
            </form>
          </DrawerBody>
          <center><DrawerFooter style={{display:'inline-block'}} >
            <div className='gap-3 d-flex'>
              <button variant='outline' className='cancel-button' mr={3} onClick={handleOnClose}>
                Cancel
              </button>
              <button className='create-button' onClick={handleSubmit} style={{backgroundColor:'#ff176b'}} >Submit</button>
            </div>
          </DrawerFooter></center>
        </DrawerContent>
      </Drawer>
    </>
  )
}
export default ContractForm;